import { render } from "./UserReferralCodeSavePartial.vue?vue&type=template&id=add27970"
import script from "./UserReferralCodeSavePartial.vue?vue&type=script&lang=js"
export * from "./UserReferralCodeSavePartial.vue?vue&type=script&lang=js"
script.render = render

export default script